import React from 'react';
import { Button, Grid } from '@mui/material';
import { Link } from 'react-router-dom';
import './pageHeader.css';
import { ROUTES_LIST } from '../../../helpers/routesList';
import { useParams } from 'react-router';

export default function PageHeader({
    pageName,
    addNewLink,
    showAddNew = true,
    addNewLinkAgain = false,
}) {
    const { epgProgramId } = useParams();

    return (
        <Grid
            container
            direction="row"
            justifyContent="space-between"
            alignItems="center"
        >
            <h3>{pageName}</h3>
            <span>
                {showAddNew && (
                    <Link to={addNewLink} className="create-button">
                        <Button
                            size="small"
                            color="secondary"
                            variant="contained"
                            style={{ backgroundColor: 'forestgreen' }}
                        >
                            {pageName} нэмэх
                        </Button>
                    </Link>
                )}
                {addNewLinkAgain && (
                    <Link
                        to={`${ROUTES_LIST.programFileList}/${epgProgramId}`}
                        className="create-button"
                    >
                        <Button
                            size="small"
                            color="secondary"
                            variant="contained"
                            // style={{ backgroundColor: 'forestgreen' }}
                        >
                            {pageName} файлаар нэмэх
                        </Button>
                    </Link>
                )}
            </span>
        </Grid>
    );
}

// PageHeader.propTypes = {
//     pageName: PropTypes.string,
//     addNewLink: PropTypes.string,
// };
